import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { clientsAPISlice } from './slices/clientsAPISlice';
import { usersAPISlice } from './slices/usersAPISlice';
import { customersAPISlice } from './slices/customersAPISlice';
import { invoicesAPISlice } from './slices/invoicesAPISlice';
import { paymentsAPISlice } from './slices/paymentsAPISlice';
import { webhooksAPISlice } from './slices/webhooksAPISlice';
import { reportsAPISlice } from './slices/reportsAPISlice';
import { paymentMatchingSlice } from './slices/paymentMatchingSlice';
import { emailsAPISlice } from './slices/emailAPISlice';
import { serviceLineAPISlice } from './slices/serviceLineAPISlice';
import { customerPausesAPISlice } from './slices/customerPausesAPISlice';
import { bopViewDefinitionsAPISlice } from './slices/BOPViewDefinitionsAPISlice';
import { analyticsAPISlice } from './slices/analyticsAPISlice';

export const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      clientsAPISlice.middleware,
      usersAPISlice.middleware,
      customersAPISlice.middleware,
      invoicesAPISlice.middleware,
      paymentsAPISlice.middleware,
      webhooksAPISlice.middleware,
      reportsAPISlice.middleware,
      emailsAPISlice.middleware,
      serviceLineAPISlice.middleware,
      customerPausesAPISlice.middleware,
      bopViewDefinitionsAPISlice.middleware,
      analyticsAPISlice.middleware
    ),
  reducer: {
    [clientsAPISlice.reducerPath]: clientsAPISlice.reducer,
    [usersAPISlice.reducerPath]: usersAPISlice.reducer,
    [customersAPISlice.reducerPath]: customersAPISlice.reducer,
    [invoicesAPISlice.reducerPath]: invoicesAPISlice.reducer,
    [paymentsAPISlice.reducerPath]: paymentsAPISlice.reducer,
    [webhooksAPISlice.reducerPath]: webhooksAPISlice.reducer,
    [reportsAPISlice.reducerPath]: reportsAPISlice.reducer,
    [paymentMatchingSlice.reducerPath]: paymentMatchingSlice.reducer,
    [emailsAPISlice.reducerPath]: emailsAPISlice.reducer,
    [serviceLineAPISlice.reducerPath]: serviceLineAPISlice.reducer,
    [customerPausesAPISlice.reducerPath]: customerPausesAPISlice.reducer,
    [bopViewDefinitionsAPISlice.reducerPath]: bopViewDefinitionsAPISlice.reducer,
    [analyticsAPISlice.reducerPath]: analyticsAPISlice.reducer,
  },
});

setupListeners(store.dispatch);

export type IState = ReturnType<typeof store.getState>;

export type RootState = ReturnType<typeof store.getState>;
